export const adminNavItems = [
  { title: "Dashboard", link: "/dashboard" },
  { title: "Users", link: "/users" },
  { title: "Queries", link: "/queries" },
  { title: "Service Leads", link: "/service-leads" },
  { title: "Bugs Report", link: "/bugs-report" },
  { title: "My Profile", link: "/myprofile" },
  { title: "Tickets", link: "/support" },
];

export const getRouteLinkIndexAdmin = () => {
  if (typeof window === "undefined") return null;

  const currentPath = window.location.pathname;
  const currentItem = adminNavItems.find(
    (item) =>
      item.link === currentPath ||
      (item.link !== "/dashboard" && currentPath.startsWith(item.link)),
  );

  return currentItem || { title: "Dashboard", link: "/dashboard" };
};
